import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router'

import ButtonBS from '../../../components/common/ButtonBS';
import ScamLayout from '../../../components/common/PageLayout/ScamLayout';
import translations from '../../../middlewares/i18n/ScamScreen.json';

import { getDirectionFromList } from '../../../actions/viewActions'

import useTranslations from '../../../hooks/useTranslations';

import '../../../styles/ScamScreen/ScamScreen.new.css';

import { usStatesAndTerritories } from '../../../helpers/us_states';

const StateNotice = () => {
  const dispatch = useDispatch();
  const i18n = useTranslations(translations);
  const language = useSelector(state => state.i18n.language.current);

  const client = useSelector(state => state.client);

  const handleNextPage = useCallback(() => {
    dispatch(push(dispatch(getDirectionFromList())));
  }, []);

  const getState = () => {
    if (client.state_notice && client.state_notice.state) {
      if (usStatesAndTerritories[client.state_notice.state]) {
        return usStatesAndTerritories[client.state_notice.state];
      }
      return client.state_notice.state;
    }
    return null;
  }

  const notice = () => {
    if (!client.state_notice) return null;
    try {
      return JSON.parse(client.state_notice.notice)[language];
    } catch (error) {
      return client.state_notice.notice
    }
  }

  return (
    <>
      <ScamLayout showSender={false} showBeingScammed={false}>
        <div className="scam-screen">
          <div className="scam-logo scam-screen-logo" />
          <h6 className="scam-screen__title">{i18n.stateRestriction}</h6>
          <p className="scam-screen__subtitle">{i18n.stateRestrictionSubtitle1} {getState()} {i18n.stateRestrictionSubtitle2}</p>
          <div className="scam-layout__divider" /> 
          <div className="state-notice__limits-cards">
            <div>
              <h4>{i18n.restrictions}</h4>
              { client && client.state_notice && client.state_notice.state_notice_limits && client.state_notice.state_notice_limits.map((limit, index) => (
                <p key={index}>{limit.disclaimer}</p>
              ))}
            </div>
          </div>
          <h6 className="scam-screen__title">{i18n.noticeFromYourState}</h6>
          <div className="state-notice__card"> 
            <p className="state-notice__card-example">{notice()}</p>
          </div>

        </div>
      </ScamLayout>

      <div className="state-notice__buttons">
        <ButtonBS v2 className="v2--red last" content={i18n.stateRestrictionAcknowledgment} onClick={handleNextPage} />
      </div>
    </>
  )
}

export default StateNotice;